import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { CxQuestion } from '../../entity/entities';
import { useTranslation } from 'react-i18next';

export function QuestionText(props: { cxQuestion: CxQuestion }) {
  const { t } = useTranslation();
  const { cxQuestion } = props;

  let optionalLabel: React.ReactNode | null = null;

  if (cxQuestion.required) {
    optionalLabel = (
      <Box
        textAlign="textBottom"
        display="inline-block"
        ml={1}
        fontSize="12px"
        style={{
          verticalAlign: 'middle',
          color: 'red',
        }}
      >
        {`(${t('common.required')})`}
      </Box>
    );
  }

  return (
    <>
      <Box mx={4}>
        {/* 質問文があれば表示、なければ余白を挿入 */}
        {cxQuestion.questionText ? (
          <Box mt={3} mb={2}>
            <Typography variant="h6" style={{ wordBreak: 'break-word' }}>
              {cxQuestion.questionText} {optionalLabel}
            </Typography>
          </Box>
        ) : (
          <Box mt={3}>{optionalLabel}</Box>
        )}
      </Box>
    </>
  );
}
